var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { frontEndApi } from '../common/utils';
import { EMAIL_RE } from '../common/utils';
import { dispatchGtmEvent } from '../common/gtm';
export function initQuestionPopup(allModules, allTriggers) {
    window.addEventListener('scroll', countScrollDistance);
    var scrollDistance = 0, prevOffset = window.pageYOffset;
    function countScrollDistance(event) {
        var delta = window.pageYOffset - prevOffset;
        prevOffset = window.pageYOffset;
        scrollDistance += Math.abs(delta);
        if (scrollDistance > window.pageYOffset * 3) {
            allModules.filter(function (m) { return m.name === 'QuestionPopup'; }).forEach(function (_a) {
                var el = _a.el;
                return initPopup(el);
            });
            window.removeEventListener('scroll', countScrollDistance);
        }
    }
    function initPopup(el) {
        var header = el.querySelector('.questionPopup-header');
        var footer = el.querySelector('.questionPopup-footer');
        var typer = el.querySelector('.questionPopup-typer');
        var countryPicker = el.querySelector('.questionPopup-countryPicker');
        var emailer = el.querySelector('.questionPopup-emailer');
        var wait = el.querySelector('.questionPopup-wait');
        var success = el.querySelector('.questionPopup-success');
        var failure = el.querySelector('.questionPopup-failure');
        var tbtn = header.querySelector('.is--toggleBtn');
        var cbtn = footer.querySelector('.is--continueBtn');
        var sbtn = footer.querySelector('.is--sendBtn');
        var countrySelect = countryPicker.querySelector('select');
        var messageInput = typer.querySelector('.-input');
        var emailInput = emailer.querySelector('.-input');
        var meta = el.dataset.meta ? JSON.parse(el.dataset.meta) : {};
        var triggers = allTriggers.filter(function (t) { return t.module === 'QuestionPopup'; });
        var steps = getSteps();
        el.classList.remove('is--inactive');
        triggers.forEach(function (_a) {
            var el = _a.el, action = _a.action;
            if (steps[action]) {
                el.addEventListener('click', function () { return steps[action](); });
            }
        });
        messageInput.addEventListener('keyup', validateInputs);
        countrySelect.addEventListener('change', function () {
            validateInputs();
            if (countrySelect.value) {
                steps.email();
            }
        });
        emailInput.addEventListener('keyup', validateInputs);
        messageInput.addEventListener('keydown', function (event) {
            if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
                steps.country();
            }
        });
        emailInput.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                steps.send();
            }
        });
        function validateInputs() {
            var valid = true;
            cbtn.disabled = false;
            sbtn.disabled = false;
            if (!messageInput.value || (steps.currentStep === 'country' && !countrySelect.value)) {
                cbtn.disabled = true;
                valid = false;
            }
            if (!EMAIL_RE.test(emailInput.value)) {
                sbtn.disabled = true;
                valid = false;
            }
            return valid;
        }
        function getSteps() {
            var step = 'hidden', block = false;
            return {
                get currentStep() {
                    return step;
                },
                toggle: function () {
                    step === 'hidden' ? this.open() : this.close();
                },
                close: function () {
                    this.hidden();
                    dispatchGtmEvent('AC.Interaction.QuestionPopup.close');
                },
                open: function () {
                    this.continue();
                    dispatchGtmEvent('AC.Interaction.QuestionPopup.open');
                },
                continue: function () {
                    switch (step) {
                        case 'type':
                            return this.country();
                        case 'country':
                            return this.email();
                        case 'email':
                            return this.send();
                        case 'hidden':
                        default:
                            return this.type();
                    }
                },
                hidden: function () {
                    if (block) {
                        return;
                    }
                    el.classList.remove('is--open');
                    typer.style.height = "0";
                    typer.classList.remove('is--active');
                    countryPicker.style.height = "0";
                    countryPicker.classList.remove('is--active');
                    emailer.style.height = "0";
                    emailer.classList.remove('is--active');
                    tbtn.focus();
                    cbtn.classList.remove('is--active');
                    sbtn.classList.remove('is--active');
                    wait.classList.remove('is--active');
                    success.classList.remove('is--active');
                    failure.classList.remove('is--active');
                    step = 'hidden';
                },
                type: function () {
                    if (block) {
                        return;
                    }
                    el.classList.add('is--open');
                    validateInputs();
                    typer.style.height = "".concat(typer.scrollHeight, "px");
                    typer.classList.add('is--active');
                    countryPicker.style.height = "0";
                    countryPicker.classList.remove('is--active');
                    emailer.style.height = "0";
                    emailer.classList.remove('is--active');
                    messageInput.focus();
                    cbtn.classList.add('is--active');
                    sbtn.classList.remove('is--active');
                    wait.classList.remove('is--active');
                    success.classList.remove('is--active');
                    failure.classList.remove('is--active');
                    step = 'type';
                },
                country: function () {
                    if (block) {
                        return;
                    }
                    validateInputs();
                    countrySelect.focus();
                    typer.style.height = "".concat(typer.scrollHeight, "px");
                    typer.classList.add('is--active');
                    countryPicker.style.height = "".concat(countryPicker.scrollHeight, "px");
                    countryPicker.classList.add('is--active');
                    emailer.style.height = "0";
                    emailer.classList.remove('is--active');
                    cbtn.classList.add('is--active');
                    sbtn.classList.remove('is--active');
                    wait.classList.remove('is--active');
                    success.classList.remove('is--active');
                    failure.classList.remove('is--active');
                    step = 'country';
                },
                email: function () {
                    if (block) {
                        return;
                    }
                    el.classList.add('is--open');
                    validateInputs();
                    typer.style.height = "".concat(typer.scrollHeight, "px");
                    typer.classList.add('is--active');
                    countryPicker.style.height = "".concat(countryPicker.scrollHeight, "px");
                    countryPicker.classList.add('is--active');
                    emailer.style.height = "".concat(emailer.scrollHeight, "px");
                    emailer.classList.add('is--active');
                    emailInput.focus();
                    cbtn.classList.remove('is--active');
                    sbtn.classList.add('is--active');
                    wait.classList.remove('is--active');
                    success.classList.remove('is--active');
                    failure.classList.remove('is--active');
                    step = 'email';
                },
                send: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var ok, err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (block) {
                                        return [2 /*return*/];
                                    }
                                    if (!validateInputs()) return [3 /*break*/, 5];
                                    block = true;
                                    el.classList.add('is--open');
                                    wait.classList.add('is--active');
                                    step = 'send';
                                    ok = false;
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, frontEndApi.post('Common@sendContactEmail', {
                                            email: emailInput.value,
                                            country: countrySelect.value,
                                            message: messageInput.value,
                                            consent: true,
                                            meta: Object.assign({}, meta, {
                                                ui: 'QuestionPopup',
                                                url: location.href,
                                            }),
                                        })];
                                case 2:
                                    _a.sent();
                                    ok = true;
                                    dispatchGtmEvent('AC.ContactRequest.Submit.success', {
                                        formId: 'QuestionPopup',
                                    });
                                    return [3 /*break*/, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    ok = false;
                                    console.warn(err_1);
                                    dispatchGtmEvent('AC.ContactRequest.Submit.failure', {
                                        formId: 'QuestionPopup',
                                        failureReason: err_1,
                                    });
                                    return [3 /*break*/, 4];
                                case 4:
                                    block = false;
                                    ok ? this.success() : this.failure();
                                    _a.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    });
                },
                success: function () {
                    if (block) {
                        return;
                    }
                    this.hidden();
                    el.classList.add('is--open');
                    success.classList.add('is--active');
                    messageInput.value = '';
                    countrySelect.value = '';
                    emailInput.value = '';
                    el.classList.add('is--sent');
                    tbtn.focus();
                    step = 'success';
                },
                failure: function () {
                    if (block) {
                        return;
                    }
                    this.hidden();
                    el.classList.add('is--open');
                    failure.classList.add('is--active');
                    tbtn.focus();
                    step = 'failure';
                },
            };
        }
    }
}
